<!-- 表具实时数据 -->
<template>
  <a-row :gutter="24">
    <a-col :md="24" :sm="24" style="position: relative;padding-left: 30px">
      <a-card :bordered="false">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('表编号')">
                  <a-input  :placeholder="$t('请输入表编号查询')" v-model="queryParam.meterId"></a-input>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('模组号')">
                  <a-input  :placeholder="$t('请输入模组号查询')" v-model="queryParam.meterImei"></a-input>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                  <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <div>
            <template v-if="dataSource.length==0">
                <a-empty />
            </template>
            <template v-else>
                <p>{{ $t('运行密钥') }}: 
                  <template v-if="dataSource[0].meterRunKey==null">--</template> 
                  <template v-else>{{dataSource[0].meterRunKey|hexCharCodeToStr}}</template>
                </p>
                <p>{{ $t('根密钥') }}: 
                  <template v-if="dataSource[0].meterRootKey==null">--</template>
                  <template v-else>
                  {{dataSource[0].meterRootKey|hexCharCodeToStr}}
                  </template>
                </p>
            </template>
        </div>
      </a-card>
    </a-col>
  </a-row>  
</template>

<script>
  import { getAction } from '@/api/manage'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { hexCharCodeToStr } from '@/utils/util'
  import {isEmptyObject} from'@/utils/validate'

  export default {
    name: 'searchEncryptionKey',
    components: {
    },
    filters: {hexCharCodeToStr},
    mixins:[JeecgListMixin],
    data () {
      return {
        description: 'search_encryption_key管理页面',
        columns: [],
        url: {
          list: "/jeecg-charge/meter/meterMaintenanceWarnLastRecord/queryEncryptionKeyPageList"
        },
        disableMixinCreated: true
      }
    },
    created() {
    },
    methods: {
      loadData(arg) {
        this.dataSource = [];
        if(isEmptyObject(this.queryParam)) {
          return;
        }
        //加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
            this.ipagination.current = 1;
        }
        var params = this.getQueryParams();//查询条件
        this.loading = true;
        getAction(this.url.list, params).then((res) => {
          console.log(res.result.records.length)
            if (res.success) {
                this.dataSource = res.result.records
            }
            if(res.code===510){
            this.$message.warning(res.message)
            }
            this.loading = false;
        })
      },
    }
  }
</script>
<style scoped>
</style>